import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { labourUploadDocApi } from '../api/labourUploadDocApi'; 
import { RootState } from '..';

export interface LabourUploadDocState {
  labourUploadDocDetails: any;
  loading: boolean;
  error: string | null;
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: LabourUploadDocState = {
  labourUploadDocDetails: null,
  loading: false,
  error: null,
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

const labourUploadDocSlice = createSlice({
  name: 'labourUploadWork',
  initialState,
  reducers: {
    setUploadDocDetails: (state, action: PayloadAction<any>) => {
      state.labourUploadDocDetails = action.payload;
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    reset: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        labourUploadDocApi.endpoints.saveLabourDocumentDetail.matchPending,
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        labourUploadDocApi.endpoints.saveLabourDocumentDetail.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.labourUploadDocDetails = action.payload;
          state.error = null;
        }
      )
      .addMatcher(
        labourUploadDocApi.endpoints.saveLabourDocumentDetail.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message || 'Something went wrong';
        }
      );
  },
});

// Action creators are generated for each case reducer function
export const { setUploadDocDetails, setLoading, setError, reset } = labourUploadDocSlice.actions;
export const getUploadDocDetails = (state: RootState) => state.labour.data;
export const getUploadDocDetailsTotalRecords = (state: RootState) => state.labour.totalRecords;

export default labourUploadDocSlice.reducer;